module.exports = "../../../../platform/assets/pageMainIcon/jichudanganlei3.svg";